import { c as _c } from "react/compiler-runtime";
import { EMPTY_SEARCH_RESULT_MESSAGE } from '../constants';
export function SearchEmptyResults() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex min-h-[320px] items-center justify-center"><p className="text-center text-Gray-550 typo-body4">{EMPTY_SEARCH_RESULT_MESSAGE}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}